export function computeClientPricing(adjustedTotal: number, commissionPct: number) {
    const priceBeforeCommission = Math.ceil(adjustedTotal);
    const commissionAmount = priceBeforeCommission * commissionPct;
    const clientPrice = Math.ceil(priceBeforeCommission + commissionAmount);
    return {
        priceBeforeCommission,
        commissionAmount,
        clientPrice,
        netToCompany: priceBeforeCommission,
    };
}

// ponytail: self-check — commission is added on top, not deducted from client price.
const demo = computeClientPricing(10_000, 0.01);
if (demo.clientPrice !== 10_100 || demo.netToCompany !== 10_000) {
    throw new Error('commissionPricing self-check failed');
}
